/**
 * Format price from cents to dollar string
 */
export const formatPrice = (priceInCents: number): string => {
  return `$${(priceInCents / 100).toFixed(2)}`;
};

/**
 * Format usage display with limit (for total lifetime usage)
 */
export const formatUsageDisplay = (used: number, limit: number | null): string => {
  if (limit === null) {
    return `${used} total`;
  }
  return `${used} / ${limit} total`;
};

/**
 * Format subscription status for display
 */
export const formatSubscriptionStatus = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'active':
      return 'Active';
    case 'canceled':
      return 'Canceled';
    case 'past_due':
      return 'Past Due';
    case 'incomplete':
      return 'Incomplete';
    default:
      return status;
  }
};

/**
 * Get status badge variant based on subscription status
 */
export const getStatusBadgeVariant = (status: string): 'default' | 'secondary' | 'destructive' | 'outline' => {
  switch (status.toLowerCase()) {
    case 'active':
      return 'default';
    case 'canceled':
    case 'past_due':
      return 'destructive';
    case 'incomplete':
      return 'outline';
    default:
      return 'secondary';
  }
};